module.exports = __webpack_public_path__ + "img/square-divide.e2881c80.svg";